var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],class:`${_vm.$vuetify.breakpoint.xs ? 'mx-1' : 'mx-auto'} ${
    _vm.outlined ? 'outlined' : ''
  } ${_vm.rounded ? 'rounded-lg' : ''} d-flex flex-column`,style:(`${
    _vm.resizableMaxWidth ? `max-width: ${_vm.contentWidth}px` : ''
  } ${_vm.styles}`)},[_vm._t("header"),_c('div',{ref:"resizableDiv",class:`${_vm.bodyStyle}`},[_vm._t("table",null,{"tableHeight":_vm.tableHeight})],2),(!_vm.hideFooter)?_c('v-card',{staticClass:"py-2",staticStyle:{"background-color":"transparent"},attrs:{"flat":""}},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }